import {v4 as uuidv4} from 'uuid';

let rng = null;

window.onload = (event) => {
  console.log('The page has fully loaded. ', event);
  rng = localStorage.getItem("rng");
  if (!rng) {
    rng  = uuidv4();
    localStorage.setItem("rng", rng);
  }
  document.getElementById('rngValue').innerHTML = rng;
  console.log('rng', localStorage.getItem("rng"));
};

const GET_RNG_EVENT = 'getRng';

/**
 * Receiving message from other domain
 */
window.addEventListener('message', function(event) {
  // console.log("message getRng event: ", event);
  if (event.data === GET_RNG_EVENT) {
    //var msg = JSON.parse(event.data);
    // var msgKey = Object.keys(msg)[0];
    // console.log("message getRng Event");
    rng = localStorage.getItem("rng");
    if (!rng) {
      rng  = uuidv4();
      localStorage.setItem("rng", rng);
    }
    document.getElementById('rngValue').innerHTML = rng;
    event.source.postMessage({rngResponse: rng}, event.origin);
  }
  // console.log("getRng Complete");
});
